var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import { Button, MagicBox, useToasts } from '@brg/ui';
import urlApi from '../../../../../actions/urlApi';
import { LayoutConst } from '../../../../../core/modules/layout.module';
// import svgimage from '../../../../../images/redarr.svg'
var ButtonText = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  font-family: inherit;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 42px;\n  line-height: 48px;\n  letter-spacing: -0.02em;\n  color: #FEFEFE;\n  margin-bottom: 48px;\n  &:before {\n    content: '';\n    display: inline-block;\n    position: absolute;\n    left: -100px;\n    top: -19px;\n    width: 81px;\n    height: 90px;\n    background: url(", ") no-repeat center;\n  }\n  @media (max-width: ", "px) {\n    padding-left: 16px;\n    font-weight: 600;\n    font-size: 22px;\n    line-height: 28px;\n    margin-bottom: 16px;\n  }\n\n"], ["\n  position: relative;\n  font-family: inherit;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 42px;\n  line-height: 48px;\n  letter-spacing: -0.02em;\n  color: #FEFEFE;\n  margin-bottom: 48px;\n  &:before {\n    content: '';\n    display: inline-block;\n    position: absolute;\n    left: -100px;\n    top: -19px;\n    width: 81px;\n    height: 90px;\n    background: url(", ") no-repeat center;\n  }\n  @media (max-width: ", "px) {\n    padding-left: 16px;\n    font-weight: 600;\n    font-size: 22px;\n    line-height: 28px;\n    margin-bottom: 16px;\n  }\n\n"])), function (props) { return props.svgimage; }, LayoutConst.screen.s);
var unrecognized_territory = 'Territory is unrecognized.';
var unrecognized_longread = 'Longread is unrecognized.';
var ButtonModule = function (props) {
    var textParameters = props.textParameters, isButton = props.isButton, specBlockProps = props.specBlockProps, history = props.history, idLongRead = props.idLongRead, post = props.post, thematic = props.thematic;
    var error = useToasts().error;
    var _a = specBlockProps || {}, externalCountry = _a.externalCountry, externalArea = _a.externalArea, isArea = _a.isArea;
    var areaId = (externalCountry &&
        externalCountry.country &&
        externalCountry.country.areaId) || (externalArea &&
        externalArea.area &&
        externalArea.area.id);
    var idCountry = !isArea
        ? externalCountry && externalCountry.country && externalCountry.country.countryId
        : undefined;
    var buttonText = textParameters.textObject && textParameters.textObject.name
        ? textParameters.textObject.name.replace(':', '')
        : '';
    var redirectAction = useCallback(function (url) {
        if (typeof (history) === 'object') {
            history.push(url);
            return;
        }
        window.location.href = window.location.origin + url;
    }, [history]);
    var collectAction = useCallback(function () {
        var asyncAction = function () { return __awaiter(void 0, void 0, void 0, function () {
            var longreadInfo, territoryLongreads, museums, collectMuseum, url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        longreadInfo = undefined;
                        if (!isArea) return [3 /*break*/, 1];
                        longreadInfo = { typeLongread: thematic };
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, urlApi().getCountryLongreads({ countryId: idCountry })];
                    case 2:
                        territoryLongreads = _a.sent();
                        longreadInfo = territoryLongreads.data && territoryLongreads.data.length
                            ? territoryLongreads.data.find(function (longreadItem) { return longreadItem.longreadId === post.longreadId; })
                            : undefined;
                        _a.label = 3;
                    case 3:
                        if (!longreadInfo) {
                            error(unrecognized_longread);
                        }
                        return [4 /*yield*/, urlApi().getMuseums({ areaId: areaId, idCountry: idCountry })
                                .catch(function (err) { return error(err.message); })];
                    case 4:
                        museums = _a.sent();
                        collectMuseum = museums && museums.data && museums.data.length
                            ? museums.data.find(function (museum) { return museum.typeMuseum === longreadInfo.typeLongread; })
                            : undefined;
                        if (collectMuseum) {
                            url = isArea
                                ? "/area/".concat(areaId, "/museum/").concat(collectMuseum.museumId)
                                : "/country/".concat(idCountry, "/museum/").concat(collectMuseum.museumId);
                            redirectAction(url);
                        }
                        else {
                            error(unrecognized_territory);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        if ((isArea && areaId) || (!isArea && idCountry)) {
            asyncAction();
        }
        else {
            error(unrecognized_territory);
        }
    }, [externalArea, areaId, idCountry, thematic]);
    var competitionAction = useCallback(function () {
        var url = "/ratings/league";
        redirectAction(url);
    }, []);
    var onButtonClick = useCallback(function (actionKey) { return function () {
        if (!actionKey) {
            return;
        }
        switch (actionKey.toLowerCase()) {
            case 'коллекционируйте':
                collectAction();
                return;
            case 'соревнуйтесь':
                competitionAction();
                return;
            default:
                return;
        }
    }; }, [textParameters]);
    return React.createElement("div", { className: "offset-xl-4 offset-lg-4 col-xl-8 col-lg-8 spec-button-container" }, isButton
        ? React.createElement(MagicBox, { offsetBottom: 20, offsetBottomMobile: 15, className: ' spec-button-wrapper' },
            React.createElement(Button.YellowOutlineRectMedium, { onClick: onButtonClick(buttonText), className: 'spec-button' },
                React.createElement(MagicBox, { widthMobile: "100vh", justifyMobile: "center" }, buttonText)))
        : React.createElement(ButtonText
        // dangerouslySetInnerHTML={{__html: textParameters.textObject.name}}
        , null, textParameters.textObject.name));
};
export default ButtonModule;
var templateObject_1;
//# sourceMappingURL=buttonblock.js.mapvar __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import { Button, MagicBox, useToasts } from '@brg/ui';
import urlApi from '../../../../../actions/urlApi';
import { LayoutConst } from '../../../../../core/modules/layout.module';
// import svgimage from '../../../../../images/redarr.svg'
var ButtonText = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  font-family: inherit;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 42px;\n  line-height: 48px;\n  letter-spacing: -0.02em;\n  color: #FEFEFE;\n  margin-bottom: 48px;\n  &:before {\n    content: '';\n    display: inline-block;\n    position: absolute;\n    left: -100px;\n    top: -19px;\n    width: 81px;\n    height: 90px;\n    background: url(", ") no-repeat center;\n  }\n  @media (max-width: ", "px) {\n    padding-left: 16px;\n    font-weight: 600;\n    font-size: 22px;\n    line-height: 28px;\n    margin-bottom: 16px;\n  }\n\n"], ["\n  position: relative;\n  font-family: inherit;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 42px;\n  line-height: 48px;\n  letter-spacing: -0.02em;\n  color: #FEFEFE;\n  margin-bottom: 48px;\n  &:before {\n    content: '';\n    display: inline-block;\n    position: absolute;\n    left: -100px;\n    top: -19px;\n    width: 81px;\n    height: 90px;\n    background: url(", ") no-repeat center;\n  }\n  @media (max-width: ", "px) {\n    padding-left: 16px;\n    font-weight: 600;\n    font-size: 22px;\n    line-height: 28px;\n    margin-bottom: 16px;\n  }\n\n"])), function (props) { return props.svgimage; }, LayoutConst.screen.s);
var unrecognized_territory = 'Territory is unrecognized.';
var unrecognized_longread = 'Longread is unrecognized.';
var ButtonModule = function (props) {
    var textParameters = props.textParameters, isButton = props.isButton, specBlockProps = props.specBlockProps, history = props.history, idLongRead = props.idLongRead, post = props.post, thematic = props.thematic;
    var error = useToasts().error;
    var _a = specBlockProps || {}, externalCountry = _a.externalCountry, externalArea = _a.externalArea, isArea = _a.isArea;
    var areaId = (externalCountry &&
        externalCountry.country &&
        externalCountry.country.areaId) || (externalArea &&
        externalArea.area &&
        externalArea.area.id);
    var idCountry = !isArea
        ? externalCountry && externalCountry.country && externalCountry.country.countryId
        : undefined;
    var buttonText = textParameters.textObject && textParameters.textObject.name
        ? textParameters.textObject.name.replace(':', '')
        : '';
    var redirectAction = useCallback(function (url) {
        if (typeof (history) === 'object') {
            history.push(url);
            return;
        }
        window.location.href = window.location.origin + url;
    }, [history]);
    var collectAction = useCallback(function () {
        var asyncAction = function () { return __awaiter(void 0, void 0, void 0, function () {
            var longreadInfo, territoryLongreads, museums, collectMuseum, url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        longreadInfo = undefined;
                        if (!isArea) return [3 /*break*/, 1];
                        longreadInfo = { typeLongread: thematic };
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, urlApi().getCountryLongreads({ countryId: idCountry })];
                    case 2:
                        territoryLongreads = _a.sent();
                        longreadInfo = territoryLongreads.data && territoryLongreads.data.length
                            ? territoryLongreads.data.find(function (longreadItem) { return longreadItem.longreadId === post.longreadId; })
                            : undefined;
                        _a.label = 3;
                    case 3:
                        if (!longreadInfo) {
                            error(unrecognized_longread);
                        }
                        return [4 /*yield*/, urlApi().getMuseums({ areaId: areaId, idCountry: idCountry })
                                .catch(function (err) { return error(err.message); })];
                    case 4:
                        museums = _a.sent();
                        collectMuseum = museums && museums.data && museums.data.length
                            ? museums.data.find(function (museum) { return museum.typeMuseum === longreadInfo.typeLongread; })
                            : undefined;
                        if (collectMuseum) {
                            url = isArea
                                ? "/area/".concat(areaId, "/museum/").concat(collectMuseum.museumId)
                                : "/country/".concat(idCountry, "/museum/").concat(collectMuseum.museumId);
                            redirectAction(url);
                        }
                        else {
                            error(unrecognized_territory);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        if ((isArea && areaId) || (!isArea && idCountry)) {
            asyncAction();
        }
        else {
            error(unrecognized_territory);
        }
    }, [externalArea, areaId, idCountry, thematic]);
    var competitionAction = useCallback(function () {
        var url = "/ratings/league";
        redirectAction(url);
    }, []);
    var onButtonClick = useCallback(function (actionKey) { return function () {
        if (!actionKey) {
            return;
        }
        switch (actionKey.toLowerCase()) {
            case 'коллекционируйте':
                collectAction();
                return;
            case 'соревнуйтесь':
                competitionAction();
                return;
            default:
                return;
        }
    }; }, [textParameters]);
    return React.createElement("div", { className: "offset-xl-4 offset-lg-4 col-xl-8 col-lg-8 spec-button-container" }, isButton
        ? React.createElement(MagicBox, { offsetBottom: 20, offsetBottomMobile: 15, className: ' spec-button-wrapper' },
            React.createElement(Button.YellowOutlineRectMedium, { onClick: onButtonClick(buttonText), className: 'spec-button' },
                React.createElement(MagicBox, { widthMobile: "100vh", justifyMobile: "center" }, buttonText)))
        : React.createElement(ButtonText
        // dangerouslySetInnerHTML={{__html: textParameters.textObject.name}}
        , null, textParameters.textObject.name));
};
export default ButtonModule;
var templateObject_1;
//# sourceMappingURL=buttonblock.js.map